import { useCallback, useState } from 'react';
// import S3 from 'aws-sdk/clients/s3';
import { S3Client, PutObjectCommand, PutObjectCommandInput } from '@aws-sdk/client-s3';
import { s3DOConfig } from '@/services/awsS3.config';
import { uid } from '@utils/generateUID';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useS3ImageUploader = <T extends Record<string, any>>(
  onLoad: (data: T) => void,
  defaultPath = 'temporary'
) => {
  const [isLoading, setIsLoading] = useState(false);

  const uploadImage = useCallback(
    async (data: T, file: File, imageField: keyof T, path?: string) => {
      setIsLoading(true);

      const fileName = `${uid()}.${file.name.split('.').pop()}`;
      const Key = `${path || defaultPath}/${fileName}`;
      const Body = await file.arrayBuffer(); // due to error: Upload error: TypeError: readableStream.getReader is not a function
      const { region, accessKeyId, secretAccessKey, endpoint, bucketName } = s3DOConfig;

      const s3 = new S3Client({
        region,
        credentials: {
          accessKeyId,
          secretAccessKey,
        },
        endpoint, // if using DigitalOcean Spaces or custom S3
        forcePathStyle: true, // usually needed for DO Spaces
        requestChecksumCalculation: 'WHEN_REQUIRED',
      });

      const params: PutObjectCommandInput = {
        Bucket: bucketName,
        Key,
        Body,
        ContentType: file.type,
        ContentLength: file.size,
        ACL: 'public-read',
      };

      try {
        await s3.send(new PutObjectCommand(params));
        const url = `${endpoint}/${bucketName}/${Key}`;
        onLoad({ ...data, [imageField]: url });
      } catch (error) {
        console.error('Upload error:', error);
        console.error('Upload error:', JSON.stringify(error));
        // throw `Error while uploading image\n${JSON.stringify(err)}`;
      } finally {
        setIsLoading(false);
      }
    },
    [onLoad, defaultPath]
  );
  return { isLoading, uploadImage };
};
